module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thanks"
  }, [_c('h2', [_vm._v("Obrigado")]), _vm._v(" "), _c('p', [_vm._v("\n    Seu cadastro foi realizado com sucesso!\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e69a43ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thanks.vue
// module id = 64
// module chunks = 0